import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getPopularTopics } from 'services/popularTopics';
import { QuickReplyType } from 'components/MessageExtensions/QuickReplies/types';
import { DEFAULT_RETRIES } from 'utils/axios/constants';
import { MojoContextType } from 'utils/chatContext/types';
import { getCookieItem } from 'utils/browserCache';

export type PopularTopicsProps = {
  quick_replies: { quick_replies: Array<QuickReplyType> };
  fetchStatus: string;
};

const usePopularTopics = (
  mojoContext: MojoContextType,
  isPanelOpen = false,
): UseQueryResult<PopularTopicsProps> => {
  // https://jira.carvana.com/browse/NGCML-1424
  // Update mojoContext for introduction call to include geolocation for the user in order to
  const introductionCallMojoContext = {
    ...mojoContext,
    info: {
      ...mojoContext.info,
      user_info: {
        ...mojoContext.info.user_info,
        geoip_state_abbreviation: getCookieItem('CVCurrentState'),
      },
    },
  };

  const fn = async () => await getPopularTopics(introductionCallMojoContext);
  const QUERY_KEY = 'popularTopics';
  return useQuery({
    enabled: isPanelOpen,
    queryKey: [QUERY_KEY],
    queryFn: fn,
    retry: DEFAULT_RETRIES,
    retryOnMount: true,
    refetchOnWindowFocus: false,
  });
};

export { usePopularTopics };
